export const PAYMENTS_LIST_PAGE_STYLES = `
  .card { border: 1px solid #e5e7eb; border-radius: 12px; background: #fff; padding: 12px; }
  .panel { display: grid; gap: 10px; }
  .toolbar { display: flex; gap: 8px; flex-wrap: wrap; align-items: center; }
  .filters { border: 1px solid #e5e7eb; border-radius: 10px; padding: 8px 10px; background: #f9fafb; }
  .filters summary { display: flex; align-items: center; gap: 8px; }
  .filter-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin-top: 8px; }
  .filter-grid label { display: grid; gap: 6px; }
  .actions-cell { display: flex; gap: 6px; flex-wrap: wrap; align-items: center; }
  .dialog-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
  .dialog-grid label { display: grid; gap: 6px; }
  .dialog-grid .wide { grid-column: 1 / -1; }
  .error { color: #b91c1c; margin: 0; }
  .summary-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 12px; margin-bottom: 12px; }
  .summary-grid div { border: 1px solid #e5e7eb; border-radius: 8px; padding: 10px; display: flex; flex-direction: column; gap: 4px; }
  .tabs { display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap; }
  .tabs button { border: 1px solid #e5e7eb; background: #fff; border-radius: 8px; padding: 6px 12px; cursor: pointer; }
  .tabs button.active { border-color: #1d4ed8; color: #1d4ed8; font-weight: 600; }
  .section-title { display: flex; align-items: center; gap: 8px; margin: 8px 0; }
  .filters summary { display: flex; align-items: center; gap: 8px; }
  @media (max-width: 760px) { .filter-grid, .dialog-grid { grid-template-columns: 1fr; } }
`;

export function paymentStatusLabelKey(status: string): string {
  return `payments.status.${status}`;
}

export function buildPaymentsPayloadHash(payload: unknown): string {
  return btoa(JSON.stringify(payload)).slice(0, 128);
}

export interface LocalizedOption<T = string> {
  value: T;
  labelKey: string;
}
